/**
 * ranks.ts — client-side rank labels + colour fallbacks. Server is the
 * source of truth (every wire frame carries `from.color`); this is for
 * UI affordances like "show 'Administrator' next to the name" without a
 * round-trip.
 *
 * Stays in lock-step with server/src/roles.ts.
 */
import { K, type KEnum } from './types.js';

interface RankInfo { label: string; color: string; }

const TABLE: Record<number, RankInfo> = {
    [K.Banned]:             { label: 'Banned',                color: '#FF0000' },
    [K.Administrator]:      { label: 'Administrator',         color: '#FF0000' },
    [K.GameManager]:        { label: 'Game Manager',          color: '#FF6618' },
    [K.GlobalModerator]:    { label: 'Global Moderator',      color: '#FF6618' },
    [K.RetiredStaff]:       { label: 'Retired Staff',         color: '#B4BBC4' },
    [K.ForumModerator]:     { label: 'Forum Moderator',       color: '#E818FF' },
    [K.ProfileModerator]:   { label: 'Profile Moderator',     color: '#E818FF' },
    [K.SectionalModerator]: { label: 'Sectional Moderator',   color: '#FF6618' },
    [K.Developer]:          { label: 'Developer',             color: '#8f0cc7' },
    [K.EventStaff]:         { label: 'Event Staff',           color: '#0062ca' },
    [K.SimfileJudge]:       { label: 'Simfile Judge',         color: '#13CC23' },
    [K.Difficulty]:         { label: 'Difficulty Consultant', color: '#13CC23' },
    [K.Simfile]:            { label: 'Simfile Author',        color: '#13CC23' },
    [K.Music]:              { label: 'Music Producer',        color: '#F7E138' },
    [K.Elite]:              { label: 'Elite Keysmasher',      color: '#63d644' },
    [K.Veteran]:            { label: 'Veteran',               color: '#7c83d4' },
    [K.User]:               { label: 'User',                  color: '#9b77cc' },
    [K.Anon]:               { label: 'Anonymous',             color: '#9b77cc' },
};

export function rankLabel(k: KEnum | number): string {
    return TABLE[k]?.label ?? 'User';
}
export function rankColor(k: KEnum | number): string {
    return TABLE[k]?.color ?? '#9b77cc';
}
